import { string } from 'prop-types';
import React from 'react';

import camelCaseToNormal from '../../utils/camel-case-to-normal-string';

function CampaignLineChange({ fieldChanged, valueBefore, valueAfter }) {
  const [, id, field] = fieldChanged.split('.');
  const transformedField = camelCaseToNormal(field);
  return (
    <div>
      <b>
        Campaign Line {id} {transformedField}
      </b>{' '}
      {valueBefore
        ? `Changed from "${valueBefore}" to "${valueAfter}".`
        : `changed to "${valueAfter}".`}
    </div>
  );
}

CampaignLineChange.propTypes = {
  fieldChanged: string.isRequired,
  valueAfter: string.isRequired,
  valueBefore: string,
};
CampaignLineChange.defaultProps = {
  valueBefore: '',
};

export default CampaignLineChange;
